import React from 'react'
import { useSelector } from 'react-redux'
import TodoItem from './TodoItem'
import {AnimatePresence, motion} from 'framer-motion'

const container = {
  hidding: {opacity: 1},
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      staggerChildren: 0.2,
    }
  }
}

const child = {
  hidden: {y: 20, opacity: 0},
  visible: {
    y: 0,
    opacity: 1,
  }
}

function AppContent() {
    const todoList = useSelector((state) => state.todo.todoList)
    const filterStatus = useSelector((state) => state.todo.filterStatus)
    const sortedTodoList = [...todoList]
    sortedTodoList.sort((a,b) => new Date(b.time) - new Date(a.time))

    const filteredTodoList = sortedTodoList.filter((item) => {
      if(filterStatus === 'all'){
        return true;
      }
      return item.status === filterStatus
    })

  return (
    <div className='bg-gray-200 p-[2rem] border-r-[12px]'>
    <motion.div
    variants={container}
    initial='hidden'
    animate='visible'
    >
      <AnimatePresence>
        {filteredTodoList && filteredTodoList.length > 0 ? (
            filteredTodoList.map((todo) => 
                <TodoItem key={todo.id} todo={todo}/>
            ))
            : (<motion.p className='text-lg font-medium text-black-2 text-center mx-auto py-2 px-4 rounded-lg bg-gray-2 inline-block'
            variants={child}
            >No To-do Found</motion.p>
        )}
        </AnimatePresence>
    </motion.div>
    </div>
  )
}

export default AppContent